// extracted by mini-css-extract-plugin
export default {"hero":"Page_hero__21o2y","gradient":"Page_gradient__Kg4H5"};